import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "p-3",
  id: "new-physician-form"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", null, "Search Physician", -1 /* HOISTED */)
const _hoisted_4 = { class: "d-flex align-items-center justify-content-center pb-2 w-50 m-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  id: "New_Physician_Npi_Search",
  for: "New_Physician_Npi_Search"
}, "NPI Number: ", -1 /* HOISTED */)
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", null, "Physician Information", -1 /* HOISTED */)
const _hoisted_8 = { class: "d-grid px-4 py-2" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-grid mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_First_Name" }, [
  /*#__PURE__*/_createTextVNode("First Name: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_12 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_13 = { class: "d-grid mb-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_Middle_Intial" }, "MI:", -1 /* HOISTED */)
const _hoisted_15 = { class: "d-grid mb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_Last_Name" }, [
  /*#__PURE__*/_createTextVNode("Last Name:"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_17 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_18 = { class: "d-grid mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_Taxonomy_Code" }, "Taxonomy Code:", -1 /* HOISTED */)
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = { class: "d-grid mb-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_Credentials" }, "Credentials:", -1 /* HOISTED */)
const _hoisted_23 = { class: "d-grid mb-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_Npi_Number" }, [
  /*#__PURE__*/_createTextVNode("NPI No:"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_25 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_26 = { class: "d-grid mb-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_Pecos_Check" }, "PECOS Verification:", -1 /* HOISTED */)
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "d-grid mb-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_Tpi_Number" }, "Medicaid Provider Identifier:", -1 /* HOISTED */)
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h6", null, "Physician Address", -1 /* HOISTED */)
const _hoisted_33 = { class: "d-grid px-4 py-2" }
const _hoisted_34 = { class: "d-flex flex-column" }
const _hoisted_35 = { class: "d-grid mb-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_AddressLine1" }, [
  /*#__PURE__*/_createTextVNode("Address Line 1: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_37 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_38 = { class: "d-grid mb-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_AddressLine2" }, "Address Line 2:", -1 /* HOISTED */)
const _hoisted_40 = { class: "d-grid mb-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_AddressCity" }, [
  /*#__PURE__*/_createTextVNode("City: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_42 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_43 = { class: "d-grid mb-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_AddressStateCode" }, "State:", -1 /* HOISTED */)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: null }, "-- Select State --", -1 /* HOISTED */)
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "d-grid mb-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_AddressZip" }, [
  /*#__PURE__*/_createTextVNode("Zip:"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_49 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_50 = { class: "d-grid mb-2" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_Phone" }, [
  /*#__PURE__*/_createTextVNode("Primary Phone:"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_52 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_53 = { class: "d-grid mb-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_AltPhone" }, "Alternate Phone:", -1 /* HOISTED */)
const _hoisted_55 = { class: "d-flex flex-column" }
const _hoisted_56 = { class: "d-grid mb-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_Delivery_Method" }, [
  /*#__PURE__*/_createTextVNode("Order Delivery Method:"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<option value=\"null\">-- Delivery Method --</option><option value=\"1\">Axxess Physician Portal</option><option value=\"2\">Fax</option><option value=\"3\">Mail</option><option value=\"4\">Courier</option><option value=\"5\">Electronic</option><option value=\"6\">Other</option>", 7)
const _hoisted_65 = [
  _hoisted_58
]
const _hoisted_66 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_67 = {
  key: 0,
  class: "d-grid mb-2",
  id: "Physician_ElectronicDeliveryType"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { for: "New_Physician_ElectronicDeliveryType" }, [
  /*#__PURE__*/_createTextVNode("Vendor:"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("option", { value: null }, "--Select Vendor--", -1 /* HOISTED */)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "WorldView", -1 /* HOISTED */)
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_73 = { class: "d-grid mb-2" }
const _hoisted_74 = { for: "New_Physician_Fax" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Fax:")
const _hoisted_76 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_77 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_78 = { class: "d-grid mb-2" }
const _hoisted_79 = { for: "New_Physician_Email" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode("E-mail:")
const _hoisted_81 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_82 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_83 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_TypeaheadInput, {
          getData: _ctx.getNpi,
          onValueChanged: _ctx.updateAllFields,
          "results-limit": 1,
          maxlength: "10",
          placeholder: ""
        }, null, 8 /* PROPS */, ["getData", "onValueChanged"])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(`form-control ${!_ctx.v$.newPhysician.FirstName.$error ? '' : 'field-invalid'}`),
                id: "New_Physician_First_Name",
                maxlength: "50",
                name: "FirstName",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPhysician.FirstName) = $event)),
                onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.FirstName.$touch && _ctx.v$.newPhysician.FirstName.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.newPhysician.FirstName]
              ]),
              (_ctx.v$.newPhysician.FirstName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "First Name is required."))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "New_Physician_Middle_Intial",
              maxlength: "1",
              name: "MiddleName",
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPhysician.MiddleName) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.newPhysician.MiddleName]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(`form-control ${!_ctx.v$.newPhysician.LastName.$error ? '' : 'field-invalid'}`),
                id: "New_Physician_Last_Name",
                maxlength: "50",
                name: "LastName",
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPhysician.LastName) = $event)),
                onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.LastName.$touch && _ctx.v$.newPhysician.LastName.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.newPhysician.LastName]
              ]),
              (_ctx.v$.newPhysician.LastName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Last Name is required."))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "New_Physician_Taxonomy_Code",
              maxlength: "11",
              name: "TaxonomyCode",
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPhysician.TaxonomyCode) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.newPhysician.TaxonomyCode]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "New_Physician_Credentials",
              maxlength: "40",
              name: "Credentials",
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newPhysician.Credentials) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.newPhysician.Credentials]
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(`form-control ${!_ctx.v$.newPhysician.NPI.$error ? '' : 'field-invalid'}`),
                id: "New_Physician_Npi_Number",
                maxlength: "10",
                name: "NPI",
                type: "text",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newPhysician.NPI) = $event)),
                onBlur: [
                  _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.checkPecos && _ctx.checkPecos(...args))),
                  _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.NPI.$touch && _ctx.v$.newPhysician.NPI.$touch(...args)))
                ]
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.newPhysician.NPI]
              ]),
              (_ctx.v$.newPhysician.NPI.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "NPI is required."))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", {
              id: "New_Physician_Pecos_Check",
              innerHTML: _ctx.isPecosVerified
            }, null, 8 /* PROPS */, _hoisted_28)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "New_Physician_Tpi_Number",
              maxlength: "10",
              name: "TPI",
              type: "text",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newPhysician.TPI) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.newPhysician.TPI]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_31, [
      _hoisted_32,
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(`form-control ${!_ctx.v$.newPhysician.AddressLine1.$error ? '' : 'field-invalid'}`),
                id: "New_Physician_AddressLine1",
                maxlength: "75",
                name: "AddressLine1",
                type: "text",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newPhysician.AddressLine1) = $event)),
                onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.AddressLine1.$touch && _ctx.v$.newPhysician.AddressLine1.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.newPhysician.AddressLine1]
              ]),
              (_ctx.v$.newPhysician.AddressLine1.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Address is required."))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "New_Physician_AddressLine2",
              maxlength: "75",
              name: "AddressLine2",
              type: "text",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newPhysician.AddressLine2) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.newPhysician.AddressLine2]
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(`form-control ${!_ctx.v$.newPhysician.AddressCity.$error ? '' : 'field-invalid'}`),
                id: "New_Physician_AddressCity",
                maxlength: "75",
                name: "AddressCity",
                type: "text",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newPhysician.AddressCity) = $event)),
                onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.AddressCity.$touch && _ctx.v$.newPhysician.AddressCity.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.newPhysician.AddressCity]
              ]),
              (_ctx.v$.newPhysician.AddressCity.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_42, "City is required."))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              id: "New_Physician_AddressStateCode",
              name: "AddressStateCode",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newPhysician.AddressStateCode) = $event))
            }, [
              _hoisted_45,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.addressStateCode, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.value,
                  value: item.value
                }, _toDisplayString(item.text), 9 /* TEXT, PROPS */, _hoisted_46))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.newPhysician.AddressStateCode]
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(`form-control ${!_ctx.v$.newPhysician.AddressZipCode.$error ? '' : 'field-invalid'}`),
                id: "New_Physician_AddressZipCode",
                maxlength: "13",
                name: "AddressZipCode",
                type: "text",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newPhysician.AddressZipCode) = $event)),
                onBlur: [
                  _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.updateZipAddress && _ctx.updateZipAddress(...args))),
                  _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.AddressZipCode.$touch && _ctx.v$.newPhysician.AddressZipCode.$touch(...args)))
                ]
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.newPhysician.AddressZipCode]
              ]),
              (_ctx.v$.newPhysician.AddressZipCode.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Zip is required."))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(`form-control ${!_ctx.v$.newPhysician.PhoneWork.$error ? '' : 'field-invalid'}`),
                name: "PhoneWorkArray",
                id: "New_Physician_Phone",
                maxlength: "10",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newPhysician.PhoneWork) = $event)),
                onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.PhoneWork.$touch && _ctx.v$.newPhysician.PhoneWork.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.newPhysician.PhoneWork]
              ]),
              (_ctx.v$.newPhysician.PhoneWork.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Primary Phone is required."))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              name: "PhoneAltArray",
              id: "New_Physician_AltPhone",
              maxlength: "10",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newPhysician.PhoneAlternate) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.newPhysician.PhoneAlternate]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(`form-select ${!_ctx.v$.newPhysician.DeliveryType.$error ? '' : 'field-invalid'}`),
                id: "New_Physician_Delivery_Method",
                name: "DeliveryType",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newPhysician.DeliveryType) = $event)),
                onBlur: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.DeliveryType.$touch && _ctx.v$.newPhysician.DeliveryType.$touch(...args)))
              }, _hoisted_65, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelSelect, _ctx.newPhysician.DeliveryType]
              ]),
              (_ctx.v$.newPhysician.DeliveryType.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_66, "Delivery Method is required."))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          (_ctx.newPhysician.DeliveryType == 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _hoisted_68,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(`form-select ${
                                    !_ctx.v$.newPhysician.ElectronicDeliveryType.$error ? '' : 'field-invalid'
                                }`),
                    id: "New_Physician_ElectronicDeliveryType",
                    name: "ElectronicDeliveryType",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.newPhysician.ElectronicDeliveryType) = $event)),
                    onBlur: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.ElectronicDeliveryType.$touch && _ctx.v$.newPhysician.ElectronicDeliveryType.$touch(...args)))
                  }, _hoisted_71, 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelSelect, _ctx.newPhysician.ElectronicDeliveryType]
                  ]),
                  (_ctx.v$.newPhysician.ElectronicDeliveryType.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_72, "Vendor is required."))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("label", _hoisted_74, [
              _hoisted_75,
              (_ctx.newPhysician.DeliveryType == 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_76, "*"))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(`form-control ${!_ctx.v$.newPhysician.FaxNumber.$error ? '' : 'field-invalid'}`),
                name: "FaxNumberArray",
                id: "New_Physician_Fax",
                maxlength: "10",
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.newPhysician.FaxNumber) = $event)),
                onBlur: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.FaxNumber.$touch && _ctx.v$.newPhysician.FaxNumber.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.newPhysician.FaxNumber]
              ]),
              (_ctx.v$.newPhysician.FaxNumber.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_77, "Fax Number is required."))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("label", _hoisted_79, [
              _hoisted_80,
              (_ctx.newPhysician.DeliveryType == 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_81, "*"))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(`form-control ${!_ctx.v$.newPhysician.EmailAddress.$error ? '' : 'field-invalid'}`),
                id: "New_Physician_Email",
                maxlength: "100",
                name: "EmailAddress",
                type: "text",
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.newPhysician.EmailAddress) = $event)),
                onBlur: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.v$.newPhysician.EmailAddress.$touch && _ctx.v$.newPhysician.EmailAddress.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.newPhysician.EmailAddress]
              ]),
              (_ctx.v$.newPhysician.EmailAddress.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_82, "Email is required."))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_83, [
      _createElementVNode("button", {
        class: "btn btn-primary me-2 border-0",
        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.addNewPhysician()))
      }, "Save"),
      _createElementVNode("button", {
        class: "btn btn-outline-primary",
        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.closeDialog()))
      }, "Cancel")
    ])
  ]))
}